import {Component, OnInit} from '@angular/core';
import {MaintenanceService, PlannedMaintenance} from "../../../core/services/maintenance.service";
import { TranslateModule } from '@ngx-translate/core';
import {HeadlineTextComponent} from "../../components/headline-text/headline-text.component";
import {NgOptimizedImage} from "@angular/common";
import {MatCard, MatCardContent} from "@angular/material/card";
import {HeadlineWithIconComponent} from "../../components/headline-with-icon/headline-with-icon.component";
import {
  HeadlineWithIconAndInfoBoxComponent
} from "../../components/headline-with-icon-and-info-box/headline-with-icon-and-info-box.component";

@Component({
    selector: 'app-maintenance',
    host: {
        class: 'd-flex flex-column flex-1'
    },
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    standalone: true,
  imports: [TranslateModule, HeadlineTextComponent, NgOptimizedImage, MatCardContent, MatCard, HeadlineWithIconComponent, HeadlineWithIconAndInfoBoxComponent]
})
export class MaintenanceComponent implements OnInit {
  public type: string;
  public isLoading = true;
  public next_maintenance: PlannedMaintenance;

  constructor(private maintenanceService: MaintenanceService) {
    this.type = '';
    this.next_maintenance = {end_date: "", remind_from: "", start_date: "", status: ""};
  }

  ngOnInit(): void {
    this.maintenanceService.fetchStatus().subscribe({
      next: (status) => {
        this.type = status.status.toUpperCase();
        if (status.next_maintenance) {
          this.next_maintenance = status.next_maintenance;
        }
        this.isLoading = false;
      },
      error: error => {
        console.log(error);
      }
    });
  }

}
